import { lazy } from 'react';

import type { TFreightBillRouter } from './types/FreightBillRouter.types';
import type { RouteConfig } from '@/router/route.types';
import type { TPage } from '@/router/type';

import { composeRootPath } from '@/router/utils';

const PAGES: Record<TFreightBillRouter, TPage> = {
  FREIGHT_BILL_DETAILS: {
    id: 'freight-bill-details',
    name: 'Freight Details',
    path: composeRootPath('/freight-bill-details/:billNumber?'),
  },
};

const ROUTES: Record<TFreightBillRouter, RouteConfig> = {
  FREIGHT_BILL_DETAILS: {
    id: PAGES.FREIGHT_BILL_DETAILS.id,
    name: PAGES.FREIGHT_BILL_DETAILS.name,
    path: PAGES.FREIGHT_BILL_DETAILS.path,
    component: lazy(() => import('@features/FreightBill/pages/FreightBillDetails.page')),
  },
};

export default {
  PAGES,
  ROUTES,
};
